import { Component, inject, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NavbarComponent, SidebarComponent],
  template: `
    <div class="layout-container">
      <button class="mobile-toggle" (click)="toggleSidebar()" *ngIf="isCollapsed()">
        <i class="fa fa-bars"></i>
      </button>
      <app-sidebar></app-sidebar>
      <main class="content" [class.collapsed-sidebar]="isCollapsed()">
        <router-outlet></router-outlet>
      </main>
    </div>
  `,
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {
  private layoutService = inject(LayoutService);
  isCollapsed: Signal<boolean> = this.layoutService.isSidebarCollapsed;

  toggleSidebar() {
    this.layoutService.toggleSidebar();
  }
}
